import React from 'react'
import loadable from '@loadable/component'

import styled from 'styled-components'

import Typography from '../styles/Typography'
import 'normalize.css'

// Metadata components
import Seo from '../components/Seo'

// Layout components
import Nav from '../components/navbar'
import Footer from '../components/Footer'
import GlobalStyles from '../styles/GlobalStyles'

// Lazy load the cookie bar to improve page speed
const CookieBar = loadable(() => import('../components/CookieBar'))

const StyledLayout = styled.div`
  min-height: 100%;
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-template-columns: 100%;
  margin: 0;
  &.pink {
    background: var(--secondary1-10);
  }
`

const StyledMain = styled.div`
  width: 100%;
`

const Layout = ({ children, location }) => {
  const pinkTheme = location.pathname.includes('inscription-newsletter')

  return (
    <>
      <GlobalStyles />
      <Typography />
      <Seo />
      <StyledLayout className={pinkTheme && 'pink'}>
        <Nav {...location} />
        <StyledMain>{children}</StyledMain>
        <Footer theme={pinkTheme && 'pink'} />
      </StyledLayout>
      <CookieBar />
    </>
  )
}

export default Layout
